import PropTypes from 'prop-types'

import review from './Review'


const Reviews = data => data?.map(p => review(p))

Reviews.propTypes = PropTypes.arrayOf(review.propTypes)

Reviews.defaultProps = []

export default Reviews
